import script from "./friendly-news-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./friendly-news-detail.vue?vue&type=script&setup=true&lang=ts"

import "./friendly-news-detail.vue?vue&type=style&index=0&id=edde8d92&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edde8d92"]])

export default __exports__